const advertisersStrings = {
  advertisersHeader: {
    addAdvertiserBtn: 'Add Advertiser',
  },

  advertisersFilter: {
    searchBarPlaceholder: 'Advertiser ID, Name or Email',
  },

  advertisersList: {
    advertisersGridNoResultsFound: 'No results matching your search criteria',
    advertisersGridHeader: {
      advertisersNameGridHeader: 'Name',
      advertisersPhoneGridHeader: 'Phone',
      advertisersEmailGridHeader: 'Email',
      advertisersActionsGridHeader: 'Actions',
    },
    advertisersGridEditActionBtn: 'Edit',
    advertisersGridAddCampaignActionBtn: 'Add Campaign',
    advertisersGridViewCampaignsActionBtn: 'View Campaigns',
  },

  addAdvertiser: {
    formTitle: 'Advertiser Details',
    formNameFieldLabel: 'Name',
    formPhoneFieldLabel: 'Phone',
    formEmailFieldLabel: 'Email',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    formAddBtnText: 'Add',
    formEditBtnText: 'Edit',
  },
};

export default advertisersStrings;
